import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP = '355683666663';
const PHONE_DISPLAY = '+355 68 366 6663';

const QUICK_MESSAGES = [
  "Hi! I'd like recommendations for my trip 🌴",
  "Can you help me find a hotel in Saranda?",
  "Looking for the best restaurants in Tirana 🍽️",
  "Need a transfer / taxi booking 🚕",
];

const waLink = (text) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;

export const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Open WhatsApp chat"
        data-testid="whatsapp-fab"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-2xl shadow-[#25D366]/40 flex items-center justify-center text-white transition-all duration-300 hover:scale-105"
      >
        {open ? (
          <X className="w-6 h-6" />
        ) : (
          // WhatsApp glyph
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden>
            <path d="M17.5 14.4c-.3-.1-1.7-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.7-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .1.2 2 3 4.8 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.5-.3zM12 2C6.5 2 2 6.5 2 12c0 1.9.5 3.7 1.5 5.3L2 22l4.8-1.5C8.3 21.5 10.1 22 12 22c5.5 0 10-4.5 10-10S17.5 2 12 2z"/>
          </svg>
        )}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      </button>

      {/* Popover card */}
      {open && (
        <div
          className="fixed bottom-24 right-6 z-50 w-[320px] sm:w-[360px] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-in slide-in-from-bottom-4 fade-in duration-200"
          data-testid="whatsapp-popover"
        >
          <div className="bg-[#075E54] text-white px-4 py-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div>
              <div className="font-semibold text-sm">InfoPoint Albania</div>
              <div className="text-xs text-white/75 flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-green-300" /> Typically replies in minutes
              </div>
            </div>
          </div>
          <div className="px-4 py-4 bg-[#E5DDD5]/40">
            <p className="text-xs text-gray-700 mb-3 px-3 py-2 bg-white rounded-lg rounded-tl-none shadow-sm">
              Hi 👋 We're your local concierge. How can we help today?
            </p>
            <div className="space-y-1.5">
              {QUICK_MESSAGES.map((m) => (
                <a
                  key={m}
                  href={waLink(m)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-3 py-2 rounded-lg bg-white text-sm text-gray-800 hover:bg-[#DCF8C6] border border-gray-200 transition-colors"
                  data-testid="whatsapp-quick-message"
                >
                  {m}
                </a>
              ))}
            </div>
          </div>
          <a
            href={waLink('Hi InfoPoint Albania!')}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-[#25D366] hover:bg-[#1ebe57] text-white font-semibold py-3 transition-colors"
            data-testid="whatsapp-open-chat"
          >
            Open WhatsApp · {PHONE_DISPLAY}
          </a>
        </div>
      )}
    </>
  );
};
